import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  container: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: pxToRem(8),
    paddingLeft: pxToRem(16),
  },
  interruption: {
    display: 'flex',
    flexDirection: 'row',

    paddingTop: pxToRem(8),
    paddingLeft: pxToRem(16),

    backgroundColor: theme.palette.neutralLighter,
  },
  itemIcons: {
    width: pxToRem(32),
  },
  icon: {
    selectors: {
      '> .ms-Icon': {
        width: pxToRem(20),
        height: pxToRem(20),
      },
    },
  },
  itemContentContainer: {
    flexGrow: 2,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  firstRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'noWrap',
  },
  secondRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'no-wrap',
    alignItems: 'flex-start',
    margin: pxToRem(5),
  },
  itemContent: {
    flex: 1,
  },
  itemDate: {
    textAlign: 'right',
    paddingRight: pxToRem(16),
    width: pxToRem(160),
    color: theme.palette.neutralSecondary,
  },
  bottomBorder: {
    width: '100%',
    marginBottom: pxToRem(10),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  bottomBorderInterruption: {
    width: '100%',
    position: 'relative',
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  itemDateFont: {
    fontSize: pxToRem(12),
    fontWeight: 400,
  },
  verticalBarContainer: {
    height: '100%',
    paddingBottom: pxToRem(20),
  },
  verticalBar: {
    position: 'relative',
    top: 0,
    left: pxToRem(6),
    height: '100%',
    width: pxToRem(3),
    opacity: '0.3',
    borderRadius: pxToRem(5),
  },
  verticalBarCompleted: {
    backgroundColor: theme.palette.accentTeal,
  },
  verticalBarInProgress: {
    backgroundColor: theme.palette.accentTeal,
  },
  verticalBarFuture: {
    backgroundColor: theme.palette.neutralTertiary,
  },
  iconCompleted: {
    color: theme.palette.accentTeal,
  },
  iconInprogress: {
    color: theme.palette.accentTeal,
  },
  iconFuture: {
    color: theme.palette.neutralQuaternary,
  },
  iconRejected: {
    color: theme.palette.accentError,
  },
  iconRegenerated: {
    color: theme.palette.accentYellow,
  },
  iconSkipped: {
    color: theme.palette.accentYellow,
  },
});
